<template>
    <transition name="toast-fade">
        <div v-if="currentAchievement" class="achievement-toast" :class="{ dismissing: isDismissing }">
            <button class="close-btn" @click="dismiss">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M9.75 0C7.82164 0 5.93657 0.571828 4.33319 1.64317C2.72982 2.71451 1.48013 4.23726 0.742179 6.01884C0.00422452 7.80042 -0.188858 9.76082 0.187348 11.6521C0.563554 13.5434 1.49215 15.2807 2.85571 16.6443C4.21928 18.0079 5.95656 18.9365 7.84787 19.3127C9.73919 19.6889 11.6996 19.4958 13.4812 18.7578C15.2627 18.0199 16.7855 16.7702 17.8568 15.1668C18.9282 13.5634 19.5 11.6784 19.5 9.75C19.4973 7.16498 18.4692 4.68661 16.6413 2.85872C14.8134 1.03084 12.335 0.00272983 9.75 0ZM13.2806 12.2194C13.3503 12.2891 13.4056 12.3718 13.4433 12.4628C13.481 12.5539 13.5004 12.6515 13.5004 12.75C13.5004 12.8485 13.481 12.9461 13.4433 13.0372C13.4056 13.1282 13.3503 13.2109 13.2806 13.2806C13.2109 13.3503 13.1282 13.4056 13.0372 13.4433C12.9461 13.481 12.8486 13.5004 12.75 13.5004C12.6515 13.5004 12.5539 13.481 12.4628 13.4433C12.3718 13.4056 12.2891 13.3503 12.2194 13.2806L9.75 10.8103L7.28063 13.2806C7.21095 13.3503 7.12822 13.4056 7.03718 13.4433C6.94613 13.481 6.84855 13.5004 6.75 13.5004C6.65146 13.5004 6.55388 13.481 6.46283 13.4433C6.37179 13.4056 6.28906 13.3503 6.21938 13.2806C6.1497 13.2109 6.09442 13.1282 6.05671 13.0372C6.019 12.9461 5.99959 12.8485 5.99959 12.75C5.99959 12.6515 6.019 12.5539 6.05671 12.4628C6.09442 12.3718 6.1497 12.2891 6.21938 12.2194L8.68969 9.75L6.21938 7.28063C6.07865 7.13989 5.99959 6.94902 5.99959 6.75C5.99959 6.55098 6.07865 6.36011 6.21938 6.21937C6.36011 6.07864 6.55098 5.99958 6.75 5.99958C6.94903 5.99958 7.1399 6.07864 7.28063 6.21937L9.75 8.68969L12.2194 6.21937C12.2891 6.14969 12.3718 6.09442 12.4628 6.0567C12.5539 6.01899 12.6515 5.99958 12.75 5.99958C12.8486 5.99958 12.9461 6.01899 13.0372 6.0567C13.1282 6.09442 13.2109 6.14969 13.2806 6.21937C13.3503 6.28906 13.4056 6.37178 13.4433 6.46283C13.481 6.55387 13.5004 6.65145 13.5004 6.75C13.5004 6.84855 13.481 6.94613 13.4433 7.03717C13.4056 7.12822 13.3503 7.21094 13.2806 7.28063L10.8103 9.75L13.2806 12.2194Z" fill="#2870ED"/>
                </svg>
            </button>
            <div class="toast-content">
                <div class="badge-wrapper">
                    <img :src="currentAchievement.image_path"
                         class="badge-image"
                         :alt="'ALT_IMAGE_BADGE' | translate">
                </div>
                <div class="text-content">
                    <span class="toast-header">{{ $t('TOAST_ACHIEVEMENT_TITLE') }}</span>
                    <h4 class="achievement-name">{{ currentAchievement.name }}</h4>
                    <p class="achievement-desc">{{ currentAchievement.description }}</p>
                </div>
            </div>
        </div>
    </transition>
</template>
<!---------------------------------------------------------------------------->
<script>
import { mapGetters } from "vuex";

const AUTO_DISMISS_DELAY = 5000;

export default {
    name: "AchievementToast",

    data() {
        return {
            isDismissing: false,
            dismissTimer: null
        };
    },

    computed: {
        ...mapGetters(["currentAchievementToast"]),

        currentAchievement() {
            return this.currentAchievementToast;
        }
    },

    watch: {
        currentAchievement(newVal) {
            if (newVal) {
                this.startDismissTimer();
            }
        }
    },

    methods: {
        startDismissTimer() {
            this.clearDismissTimer();
            this.dismissTimer = setTimeout(() => {
                this.dismiss();
            }, AUTO_DISMISS_DELAY);
        },

        clearDismissTimer() {
            if (this.dismissTimer) {
                clearTimeout(this.dismissTimer);
                this.dismissTimer = null;
            }
        },

        dismiss() {
            this.clearDismissTimer();
            this.isDismissing = true;

            setTimeout(() => {
                this.isDismissing = false;
                this.$store.dispatch("dismissAchievementToast");
            }, 300);
        }
    },

    beforeDestroy() {
        this.clearDismissTimer();
    }
};
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
</style>
